import ScrollReveal from 'scrollreveal';

const $ = jQuery;
const  sr = new ScrollReveal();
window.SR = ScrollReveal;
window.sr = sr;
$('[data-animation-sr]').removeAttr('style').each(function(){
	let value = $(this).attr('data-animation-sr').split(' ');
	let config = {
		origin: value[0]?value[0]:'',
		distance: value[1]?value[1]:'200px',
		duration: value[2]?value[2]:1000,
		reset: value[3]?true:false,
		viewOffset: {bottom: 300, top:-200}
	}
	sr.reveal(this, config);
});

export default sr;
